// Errors Vuex

import state from './errorStates.js'
import * as getters from './errorGetters.js'
import * as mutations from './errorMutations.js'
import * as actions from './errorActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
